import { sonarHttpPostStream } from '@sonar-software/sonar-http';

export type PostBusinessContextPreviewRequest = {
	file: File;
};

export const postBusinessContextPreview = (request: PostBusinessContextPreviewRequest, signal?: AbortSignal) =>
	sonarHttpPostStream({
		requestBody: {
			fileOptions: {
				file: request.file,
				formName: 'file'
			}
		},
		signal,
		targetUri: '/api/v3/core/business-contexts/preview'
	});
